var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.001,
    viewBox: "0 0 20 20.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M951.389,1172.906a10,10,0,1,0,10,10A10,10,0,0,0,951.389,1172.906Zm5.47,7.006-3.575,3.122,3.123,3.573a1.344,1.344,0,1,1-2.023,1.769l-3.123-3.575-3.575,3.123a1.343,1.343,0,0,1-1.768-2.023l3.575-3.123-3.122-3.573a1.344,1.344,0,0,1,2.023-1.769l3.122,3.575,3.573-3.122a1.344,1.344,0,0,1,1.769,2.023Z",
    transform: "translate(-941.389 -1172.906)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel-icon.1af08a8483d32f41c458156d70a8732a.svg";
export { ForwardRef as ReactComponent };